import React from "react";

export default function PlayerIgn({ ign }) {
  return <h2 className="display-6 fs-2 fw-normal playerh1">{ign}</h2>;
}
